module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm02"
    }
  }, [_c('p', {
    staticClass: "also"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("LSO BY")]), _vm._v(" J"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("OHN")]), _vm._v(" R"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ECHY")])]), _vm._v(" "), _c('p', {
    staticClass: "also1"
  }, [_c('span', [_vm._v("NOVELS")])]), _vm._v(" "), _c('p', {
    staticClass: "also2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("City of Night")])]), _vm._v(" "), _c('p', {
    staticClass: "also3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "also3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This Day’s Death")])]), _vm._v(" "), _c('p', {
    staticClass: "also3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Vampires")])]), _vm._v(" "), _c('p', {
    staticClass: "also3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Fourth Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "also3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rushes")])]), _vm._v(" "), _c('p', {
    staticClass: "also3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bodies and Souls")])]), _vm._v(" "), _c('p', {
    staticClass: "also3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Marilyn’s Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "also3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Miraculous Day of Amalia Gómez")])]), _vm._v(" "), _c('p', {
    staticClass: "also1"
  }, [_c('span', [_vm._v("NONFICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "also2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Sexual Outlaw: A Documentary")])]), _vm._v(" "), _c('p', {
    staticClass: "also1"
  }, [_c('span', [_vm._v("PLAYS")])]), _vm._v(" "), _c('p', {
    staticClass: "also2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rushes")])]), _vm._v(" "), _c('p', {
    staticClass: "also3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tigers Wild")])]), _vm._v(" "), _c('p', {
    staticClass: "also3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Momma as She Became—but Not As She Was (one-act)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f561c422","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Also_by_John_Rechy.vue
// module id = 66
// module chunks = 0